import { createWebHistory, createRouter } from 'vue-router'

import TestPage from '@/pages/test/TestPage.vue'
import Sensor from '@/pages/sensor/Sensor.vue'
import MainPage from '@/components/MainPage.vue'

const routes = [

  {
    path: '/:mac',
    component: Sensor,
    props: true
  },

  {
    path: '/',
    component: MainPage,
  },

  {
    path: '/test',
    component: TestPage
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
